<span [ngStyle]="{display: visible ? '' : 'none'}" [ngClass]="{'no-rate-strike': showStrike===true}"
  >&nbsp;&nbsp;&nbsp;{{percentAway}}&nbsp;&nbsp;&nbsp;</span
>
